import {
  CardContent as MuiCardContent,
  styled,
} from '@mui/material'

export const CardContent = styled(MuiCardContent)({
  padding: 0,
  paddingBottom: '0 !important',
})
